import React, { useEffect } from 'react'
import { RouteComponentProps } from '@reach/router'
import { PanelContent } from '../../../components/panel-content'
import { useStateValue } from '../../../components/state'
import { Button } from '../../../components/button'
import { useDelayedBoolean } from '../../../hooks/use-delayed-boolean'
import { MapFact } from '../../../components/map-fact'

export const OceanOutfall: React.FC<RouteComponentProps> = () => {
  const [, dispatch] = useStateValue()

  // Filter map pins to desalination
  useEffect(() => {
    dispatch({
      type: 'setActiveMarkerType',
      payload: { activeMarkerType: 'wastewater-treatment' }
    })
  }, [dispatch])

  const factVisible = useDelayedBoolean({ delay: 500 })

  return (
    <PanelContent>
      <h1>Ocean outfall</h1>
      <p>
        Treated wastewater from our major wastewater treatment plants is
        returned to the sea via pipelines that discharge water into the ocean.
        It's a sustainable wastewater disposal method and we take every caution
        to protect our coastal waters from pollution.
      </p>
      <MapFact
        aboveValue='Treated wastewater has greater dilution in deeper water. Oceanic conditions, like wind and storms, also increase dilution.'
        visible={factVisible}
        position='bottom-right'
      />
      <Button href='https://www.watercorporation.com.au/Our-water/Wastewater/Ocean-outfall'>
        Learn more about ocean outfall
      </Button>
    </PanelContent>
  )
}
